import { FormlyMaterialModule } from '@ngx-formly/material';
import { FormlyMatDatepickerModule } from '@ngx-formly/material/datepicker';
import { FormlySelectModule } from '@ngx-formly/core/select';

import { FlexLayoutType } from './components/formly-types/flex-layout.type';
import { Type } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { AbstractControl } from '@angular/forms';
import { ChipsType } from './components/formly-types/chips.type';
import { MatIconType } from './components/formly-types/mat-icon.type';
import { StarRatingType } from './components/formly-types/star-rating.type';
import { TimerType } from './components/formly-types/timer.type';

/**
 * エラー表示のタイミング設定
 */
export function showError(field: FieldType) {
  if (field.formControl && field.formControl.invalid &&
    (
      (field.options!.parentForm && field.options!.parentForm.submitted)
      || (field.field.validation && field.field.validation.show))
  ) {
    return true;
  }
  return false;
}

/**
 * パスワードの同値チェック
 */
export function PasswordConfirmValidator(control: AbstractControl) {
  const { password, passwordConfirm } = control.value;
  if (!password || !passwordConfirm) {
    return null;
  }
  if (password === passwordConfirm) {
    return null;
  }
  return {'password-confirm': true};
}

/**
 * パスワードの同値チェックメッセージ
 */
export function passwordConfirmValidationMessage(err: any, field: any) {
  return `パスワードがパスワード（確認）と一致していません`;
}


/**
 * 必須項目チェックメッセージ
 */
export function requiredValidationMessage(err: any, field: any) {
  return `必須項目です`;
}
/**
 * minLengthチェックメッセージ
 */
export function minLengthValidationMessage(err: any, field: any) {
  return `${field.templateOptions.minLength} 文字以上`;
}

/**
 * maxLengthチェックメッセージ
 */
export function maxLengthValidationMessage(err: any, field: any) {
  return `${field.templateOptions.maxLength} 文字以下`;
}

/**
 * メールアドレスの有効性チェック
 */
export function EmailValidator(control: AbstractControl) {
  return !control.value || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(control.value) ? null : { 'email': true };
}

/**
 * emailチェックメッセージ
 */
export function emailValidationMessage(err: any, field: any) {
  return `正しいメールアドレスを入力してください`;
}


/**
 * かなチェック
 */
export function KanaValidator(control: AbstractControl) {
  return !control.value || /^[ぁ-んー　0-9a-zA-Z]*$/.test(control.value) ? null : { 'kana': true };
}

/**
 * かなチェックメッセージ
 */
export function KanaValidationMessage(err: any, field: any) {
  return `使用できない文字が含まれています`;
}

/**
 * 半角英数字チェック
 */
export function HankakuValidator(control: AbstractControl) {
  return !control.value || /^[0-9a-zA-Z]*$/.test(control.value) ? null : { 'hankaku': true };
}

/**
 * 半角英数字チェックメッセージ
 */
export function hankakuValidationMessage(err: any, field: any) {
  return `半角英数字で入力してください`;
}

/**
 * 半角数字チェック
 */
export function HankakuNumberValidator(control: AbstractControl) {
  return !control.value || /^[0-9]+$/.test(control.value) ? null : { 'hankaku-number': true };
}

/**
 * 半角数字チェックメッセージ
 */
export function hankakuNumberValidationMessage(err: any, field: any) {
  return `半角数字で入力してください`;
}

/**
 * パスワードチェック
 * 半角英数字をそれぞれ1種類以上含む6文字以上64文字以下
 */
export function PasswordCheckValidator(control: AbstractControl) {
  return !control.value || /^(?=.*?[a-z])(?=.*?\d)[a-z\d]{6,64}$/i.test(control.value) ? null : { 'password': true };
}

/**
 * パスワードチェックメッセージ
 */
export function passwordValidationMessage(err: any, field: any) {
  return `半角英数字を組み合わせたパスワードを入力してください`;
}


// ngx-formlyの設定
export const NGX_FORMLY_CONFIG = {
  extras: {
    lazyRender: true,
    showError: (field: FieldType) => showError(field)
  },
  types: [
    {
      name: 'flex-layout',
      component: FlexLayoutType
    },
    {
      name: "chips",
      wrappers: ['form-field'],
      component: ChipsType,
      defaultOptions: {
        defaultValue: [],
      },
    },
    { 
      name: 'mat-icon', 
      component: MatIconType 
    },
    { name: 'star-rating', 
      component: StarRatingType 
    },
    { 
      name: 'timer', 
      component: TimerType
    },
  ],
  validators: [
    { name: 'email', validation: EmailValidator },
    { name: 'kana', validation: KanaValidator },
    { name: 'hankaku', validation: HankakuValidator },
    { name: 'hankaku-number', validation: HankakuNumberValidator },
    // passwordチェック
    { name: 'password', validation: PasswordCheckValidator },
    // パスワードの同値チェック
    { name: 'password-confirm', validation: PasswordConfirmValidator },
  ],
  validationMessages: [
    { name: 'required', message: requiredValidationMessage },
    { name: 'minLength', message: minLengthValidationMessage },
    { name: 'maxLength', message: maxLengthValidationMessage },
    { name: 'email', message: emailValidationMessage },
    { name: 'kana', message: KanaValidationMessage },
    { name: 'hankaku', message: hankakuValidationMessage },
    { name: 'hankaku-number', message: hankakuNumberValidationMessage },
    { name: 'password', message: passwordValidationMessage },
    { name: 'password-confirm', message: passwordConfirmValidationMessage },
  ],
}

export const NGX_FORMLY_MODULES = [
  FormlyMaterialModule,
  FormlySelectModule,
  FormlyMatDatepickerModule,
]

export const NGX_FORMLY_COMPONENTS: Type<any>[] = [
  FlexLayoutType,
  ChipsType,
  MatIconType,
  StarRatingType,
  TimerType,
]
